export const AGENT_TYPE = {
    INTERNAL: 0,
    EXTERNAL: 1,
}